// 템플릿·공종 액션(rpc) — 설정 공종 템플릿·공종·공정 탭의 저장·삭제.
import { rpc } from "@/api/client";

export const saveTemplate = (templateId: string | null, input: unknown) => rpc("template/actions/saveTemplate", templateId, input);

export const deleteTemplate = (templateId: string) => rpc("template/actions/deleteTemplate", templateId);

export const saveTradeRows = (inputs: unknown) => rpc("template/trade-actions/saveTradeRows", inputs);

export const savePhaseRows = (inputs: unknown) => rpc("template/trade-actions/savePhaseRows", inputs);

export const saveQuoteAsTemplate = (quoteId: string, name: string) => rpc("template/actions/saveQuoteAsTemplate", quoteId, name);
